import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import { Link } from 'react-router';
import dateFormat from 'dateformat';

import { SliderHelpers } from '../../../../../../../helpers';

class NextModulesSlider extends Component {

    render() {
        
        const { nextModules, params } = this.props,
            settings = SliderHelpers.getResponsiveSliderSettings();

        return (
            <section className="row webinar-module-slider">
                <div className="col-xs-12 module-slider items-slider">

                <h4 className="h4 brand-color">Modules</h4>

                <Slider {...settings}>
                    { nextModules.map( ( module, index ) => {
                        return (
                            <div className="item-slide background-image" key={ index }>
                                <div className="text-box color-mask">

                                    <h6 className="h6 item-title">{ module.name }</h6>

                                    <h6 className="h6 item-title">{ dateFormat( module.start_date, 'fullDate' ) }</h6>

                                    <ul className="buttons-left pos-bottom">
                                        <li>

                                <Link type="button" className="btn btn-primary btn-block" to={ `/${ params.network }/training/interactive-webinars/${ params.webinarId }/series/${ params.seriesId }/module/${ module.id }` }><span className="label">View Module </span><span className="icon"><i
                                    className="fa fa-angle-right animated-right"> </i></span>
                                </Link>
                                        </li>
                                    </ul>

                            </div>
                            </div>

                        );
                    } ) }
                </Slider>
                </div>
            </section>
        );

    }

}

NextModulesSlider.propTypes = {
    nextModules: PropTypes.array.isRequired,
    params: PropTypes.object.isRequired,
};

export default NextModulesSlider;


// WEBPACK FOOTER //
// src/client/components/site/features/training/webinars/pages/elements/NextModulesSlider.js